<script setup>
  import ListeFichiersClient from '@/components/ListeFichiersClient.vue'
</script>

<template>
  <button class="back mt-4" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
  </svg>Retour</button>
  <h1>Liste des fichiers du client {{ client }}</h1>
  <div class="listeFichiers">
    <ListeFichiersClient/>
  </div>
</template>

<script>


export default {
    data() {
        return {
          client: null,
        };
    },
    created() {
      this.client = this.$route.params.client;
    },
    methods: {
      goBack() {
        const queryParams = {
          page: this.currentPage,
          searchTerm: this.searchTerm,
        };
        this.$router.go(-1);
        this.$router.push({ query: queryParams });
      },
    }
}

</script>

<style>

</style>
